/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_ANGULAR_MISALIGNMENT_HSS_RESULT,
	GET_ANGULAR_MISALIGNMENT_HSS_RESULT_ERROR,
	GET_ANGULAR_MISALIGNMENT_HSS_RESULT_SUCCESS,
	RESET_ANGULAR_MISALIGNMENT_HSS_RESULT
} from "@/stores/actions/WindDiagnosticAngularMisalignmentHss";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status: FetchStatus.Init,
	data:   { status: 0, },
	error:  {},
};

const actions = {
	[GET_ANGULAR_MISALIGNMENT_HSS_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_ANGULAR_MISALIGNMENT_HSS_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/AngularMisalignmentHSS`)
			.then((resp) =>
			{
				commit(GET_ANGULAR_MISALIGNMENT_HSS_RESULT_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_ANGULAR_MISALIGNMENT_HSS_RESULT_ERROR, error.response);
			});
	},
	[RESET_ANGULAR_MISALIGNMENT_HSS_RESULT]: ({ commit }) =>
	{
		commit(RESET_ANGULAR_MISALIGNMENT_HSS_RESULT);
	},
};

const mutations = {
	[GET_ANGULAR_MISALIGNMENT_HSS_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_ANGULAR_MISALIGNMENT_HSS_RESULT_SUCCESS]: (state, resp) =>
	{
		state.data = resp;
		state.status = FetchStatus.Loaded;
	},
	[GET_ANGULAR_MISALIGNMENT_HSS_RESULT_ERROR]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
	[RESET_ANGULAR_MISALIGNMENT_HSS_RESULT]: (state) =>
	{
		state.data.status = DiagnosticRange.undefined;
		state.status = FetchStatus.Init;
	},
};

export default {
	state,
	actions,
	mutations,
};
